import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemix: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remix, new-try, repeat"><path d="M3.75 13V4.75H19.5" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 1.75L20.25 4.75L17.25 7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 22.25L3.75 19.25L6.75 16.25" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 19.25H20.25V11" stroke="currentColor" strokeWidth="1.5"/><path d="M12 8V16" stroke="currentColor" strokeWidth="1.5"/><path d="M8 12H16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRemix;
